import React, { useEffect, useRef, useState } from "react";
import PageLayout from "../../layout/PageLayout/pageLayout";
import deleteIcon from "../../include/images/delete-icon.svg";
import { connect } from "react-redux";
import { getUserStoryDetail, saveUserStory, updateUserStory, userStoryData } from "../../store/userStory";
import AlertError from "../../common/alerts/alertError";
import { toast } from "react-toastify";
import { Amplify, Auth, Storage } from "aws-amplify";
import { v4 as uuidv4 } from "uuid";
import LoadingBar from "react-top-loading-bar";
import { Link, useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import AlertSuccess from "../../common/alerts/alertSuccess";
import Joi from "joi";
import Select from "react-select";
import { validateErrorMessage } from "../../common/validation/validation";
import { getSpeciesCategoryList, getSpeciesList } from "../../store/sidebarApis";
import NextButton from "../../common/form/nextButton";

Amplify.configure({
  Auth: {
    identityPoolId: process.env.REACT_APP_IDENTITYPOOLID,
    region: process.env.REACT_APP_S3_REGION,
  },
  Storage: {
    bucket: process.env.REACT_APP_S3_BUCKET,
    region: process.env.REACT_APP_S3_REGION,
  },
});
Auth.configure({
  Auth: {
    identityPoolId: "us-east-2:fa1d4017-2701-482a-9559-34a69f57d192", //REQUIRED - Amazon Cognito Identity Pool ID
    region: process.env.REACT_APP_S3_REGION,
  },
  Storage: {
    bucket: process.env.REACT_APP_S3_BUCKET,
    region: process.env.REACT_APP_S3_REGION,
  },
});

const promiseWithMeta = (promise, meta) => promise.then((result) => ({ result, meta }));

const customStyles1 = {
  indicatorSeparator: () => ({ display: "none" }),
  option: (provided, state) => ({
    ...provided,
    "&:hover": {
      backgroundColor: "#47ad1d",
      color: "#fff",
    },
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    color: state.isSelected ? "#fff" : "black",
    backgroundColor: state.isSelected ? "#47ad1d" : provided.backgroundColor,
  }),
  control: (base, state) => ({
    ...base,
    minHeight: 70,
    fontSize: "20px",
    border: "none",
    borderBottom: `1px solid ${state.isFocused ? "#47AD1D" : "#e4e4e4"}`,
    borderRadius: 0,
    boxShadow: "none",
    "&:hover": {
      borderBottom: `1px solid ${state.isFocused ? "#47AD1D" : "#c4c4c4"}`,
    },
  }),
  multiValueRemove: (base) => ({
    ...base,
    "&:hover": {
      backgroundColor: "rgb(95, 50, 187, 10%)",
      color: "#6119c0",
    },
  }),
};

const UpdateCustomerStory = (props) => {
  const location = useLocation();
  const history = useHistory();
  const pageType = location?.pathname?.split("/")?.[1] === "update-user-story" ? "update" : "save";
  const ref = useRef();
  const [storyData, setStoryData] = useState({
    title: "",
    contributor: "",
    mainStory: "",
    featuredImage: [],
    photos: [],
    videos: [],
    species: [],
  });
  const [selectedUploadMedia, setSelectedUploadMedia] = useState({ featuredImage: [], photos: [], videos: [] });
  const [loading, setLoading] = useState(false);
  const [loadingMain, setLoadingMain] = useState(pageType === "update" ? true : false);
  const [error, setError] = useState({});
  const [dropDownData, setDropdownData] = useState({ category: [], species: [] });

  const schema = Joi.object({
    title: Joi.string()
      .label("Title")
      .required()
      .error((errors) => validateErrorMessage(errors)),
    contributor: Joi.string()
      .label("Contributor")
      .required()
      .error((errors) => validateErrorMessage(errors)),
    mainStory: Joi.string()
      .label("Main Story")
      .required()
      .error((errors) => validateErrorMessage(errors)),
    species: Joi.array()
      .items(
        Joi.object({
          id: Joi.string(),
          name: Joi.string(),
        }),
      )
      .label("Species")
      .min(1)
      .required()
      .error((errors) => validateErrorMessage(errors)),
    photos: Joi.array().items(
      Joi.object({
        media: Joi.string(),
        mediaType: Joi.string().valid("image", "video"),
      }),
    ),
    videos: Joi.array().items(
      Joi.object({
        media: Joi.string(),
        mediaType: Joi.string().valid("image", "video"),
      }),
    ),
    featuredImage: Joi.array().items(
      Joi.object({
        media: Joi.string(),
        mediaType: Joi.string().valid("image", "video"),
      }),
    ),
  });

  const validate = () => {
    const error = schema.validate(storyData, { abortEarly: false });
    if (error.error && error.error.details) {
      const errors = {};
      error.error.details.forEach((element) => {
        errors[element.context.key] = element.message;
      });
      setError(errors);
      return false;
    }
    setError("");
    return true;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    props?.getSpeciesCategoryList({}, (res) => {
      if (res?.status === 200) {
        const data = { ...dropDownData };
        data.category = res?.data?.data;
        data.species = res?.data?.data?.flatMap((it) => it?.species) || [];
        setDropdownData(data);
      }
    });
  }, []);

  useEffect(() => {
    if (pageType === "update") {
      ref?.current?.continuousStart();
      const slug = location?.pathname?.split("/")?.[2];
      props?.getUserStoryDetail({}, slug, (res) => {
        if (res?.status === 200) {
          const data = { ...storyData };
          const response = res?.data?.data;
          data.title = response?.title;
          data.contributor = response?.contributor;
          data.mainStory = response?.mainStory;
          data.featuredImage = response?.featuredImage?.map((ye) => ({
            media: ye?.original,
            mediaType: "image",
          }));
          data.photos = response?.files
            ?.filter((it) => it?.mediaType === "image")
            ?.map((ye) => ({
              media: ye?.original,
              mediaType: "image",
            }));
          data.videos = response?.files
            ?.filter((it) => it?.mediaType === "video")
            ?.map((ye) => ({
              media: ye?.original,
              mediaType: "video",
            }));
          data.species = response?.species?.map((iy) => ({
            name: iy?.displayCommonName,
            id: iy?._id,
          }));
          setStoryData(data);

          setLoadingMain(false);
          ref?.current?.complete();
        } else if (res?.status != 200) {
          toast(<AlertError message={res?.data?.message || "Something went wrong!!"} />);
        }
      });
    }
  }, []);

  const onChange = (e) => {
    const data = { ...storyData };
    data[e.target.name] = e.target.value;
    setStoryData(data);
  };

  const removeExistingImages = (res, field) => {
    if (field === "featuredImage") {
      const data = { ...storyData };
      data.featuredImage = [];
      setStoryData(data);
    } else if (field === "photos") {
      const data = { ...storyData };
      const a = Array.from(storyData?.photos)?.filter((item) => item?.media !== res);
      data.photos = a;
      setStoryData(data);
    } else if (field === "videos") {
      const data = { ...storyData };
      const a = Array.from(storyData?.videos)?.filter((item) => item?.media !== res);
      data.videos = a;
      setStoryData(data);
    }
  };

  const removeUploaded = (res, field) => {
    if (field === "featuredImage") {
      const data = { ...selectedUploadMedia };
      data.featuredImage = [];
      setSelectedUploadMedia(data);
    } else if (field === "photos") {
      const data = { ...selectedUploadMedia };
      const a = Array.from(selectedUploadMedia?.photos)?.filter((item) => item?.name !== res?.name);
      data.photos = a;
      setSelectedUploadMedia(data);
    } else if (field === "videos") {
      const data = { ...selectedUploadMedia };
      const a = Array.from(selectedUploadMedia?.videos)?.filter((item) => item?.name !== res?.name);
      data.videos = a;
      setSelectedUploadMedia(data);
    }
  };

  const onSelectMedia = (e, type, field) => {
    const imageContainer = [];
    for (let i = 0; i < e.target.files.length; i++) {
      const fSize = Math.round(e.target.files[i].size / 1048576);
      const fType = e.target.files[i].type;
      if (fSize > 25) {
        toast(<AlertError message="File size exceeds maximum allowable size. Maximum allowable size is 25MB." />);
        return;
      } else if (
        type === "videos"
          ? !["video/mp4", "video/mov", "video/avi"].includes(fType)
          : !["image/jpeg", "image/jpg", "image/png", "image/webp"].includes(fType)
      ) {
        toast(
          <AlertError
            message={
              type === "videos"
                ? "File is not of correct format and hence cannot be uploaded. Valid video formats are MP4, MOV and AVI."
                : "File is not of correct format and hence cannot be uploaded. Valid image formats are  JPG, JPEG, PNG and WEBP ."
            }
          />,
        );
        return;
      } else {
        imageContainer.push(e.target.files[i]);
      }
    }

    if (field === "featuredImage") {
      const value = { ...selectedUploadMedia };
      value.featuredImage = [...imageContainer];
      setSelectedUploadMedia(value);
    } else if (field === "photos") {
      const value = { ...selectedUploadMedia };
      value.photos = [...imageContainer, ...selectedUploadMedia?.photos];
      setSelectedUploadMedia(value);
    } else if (field === "videos") {
      const value = { ...selectedUploadMedia };
      value.videos = [...imageContainer];
      setSelectedUploadMedia(value);
    }
  };

  const onUpload = async () => {
    try {
      setLoading(true);
      ref?.current?.continuousStart();
      const promiseContainer = [];

      // Featured Image
      const featuredImage = selectedUploadMedia?.featuredImage?.[0];
      if (featuredImage) {
        const fileName = `featured-${uuidv4()}.${featuredImage?.name?.split(".").pop()}`;
        const featuredImagePromise = Storage.put(fileName, featuredImage, {
          completeCallback: () => {},
          progressCallback: () => {},
          errorCallback: () => {},
        });
        promiseContainer.push(promiseWithMeta(featuredImagePromise, { id: "featuredImage" }));
      }

      // Photos
      for (let i = 0; i <= selectedUploadMedia?.photos?.length - 1; i++) {
        const file = selectedUploadMedia?.photos[i];
        const fileName = `image-${uuidv4()}.${file?.name?.split(".").pop()}`;
        const photoPromise = Storage.put(fileName, file, {
          completeCallback: () => {},
          progressCallback: () => {},
          errorCallback: () => {},
        });
        promiseContainer.push(promiseWithMeta(photoPromise, { id: "image" }));
      }

      // Videos
      for (let i = 0; i <= selectedUploadMedia?.videos?.length - 1; i++) {
        const file = selectedUploadMedia?.videos[i];
        const fileName = `video-${uuidv4()}.${file?.name?.split(".").pop()}`;
        const videoPromise = Storage.put(fileName, file, {
          completeCallback: () => {},
          progressCallback: () => {},
          errorCallback: () => {},
        });
        promiseContainer.push(promiseWithMeta(videoPromise, { id: "video" }));
      }
      return Promise.all(promiseContainer);
    } catch (error) {
      console.error("Upload failed:", error);
      return [];
    }
  };

  const onSubmit = async () => {
    if (!validate()) return;

    if (selectedUploadMedia?.featuredImage?.length === 0 && storyData?.featuredImage?.length == 0) {
      const errors = { ...error };
      errors.featuredImage = "Featured Image is required";
      setError(errors);
      return;
    }

    const uploadedMediaResult = await onUpload();

    const featuredImage = [
      uploadedMediaResult?.filter((it) => it?.meta?.id === "featuredImage")?.[0]?.result?.key && {
        mediaType: "image",
        media: "public/" + uploadedMediaResult?.filter((it) => it?.meta?.id === "featuredImage")?.[0]?.result?.key,
      },
    ].filter(Boolean);
    const media = uploadedMediaResult
      ?.filter((je) => je?.meta?.id !== "featuredImage" && je?.result?.key)
      ?.map((it) => ({
        mediaType: it?.meta?.id,
        media: "public/" + it.result.key,
      }))
      .filter(Boolean);

    const payload = {
      title: storyData?.title,
      contributor: storyData?.contributor,
      mainStory: storyData?.mainStory,
      featuredImage: [...featuredImage, ...storyData?.featuredImage],
      files: [...media, ...storyData?.photos, ...storyData?.videos],
      species: storyData?.species?.map((it) => it?.id),
    };

    if (pageType === "update") {
      const slug = location?.pathname?.split("/")?.[2];
      props?.updateUserStory(slug, payload, (res) => {
        if (res && res?.status == 200) {
          setLoading(false);
          ref?.current?.complete();
          toast(<AlertSuccess message={res?.data?.message || "Story Updated Successfully"} />);
          history.push("/my-stories");
        } else {
          setLoading(false);
          ref?.current?.complete();
          toast(<AlertError message={res?.data?.message || "Something went wrong!!"} />);
        }
      });
    } else {
      props?.saveUserStory(payload, (res) => {
        if (res && res?.status === 200) {
          setLoading(false);
          ref?.current?.complete();
          toast(<AlertSuccess message={res?.data?.message || "Story Saved Successfully"} />);
          history.push("/my-stories");
        } else {
          setLoading(false);
          ref?.current?.complete();
          toast(<AlertError message={res?.data?.message || "Something went wrong!!"} />);
        }
      });
    }
  };

  return (
    <>
      <LoadingBar height={5} color="#47AD1D" ref={ref} />

      <PageLayout>
        <div class="content-container story-new-container">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div class="breadcrumb-row d-flex flex-wrap mb-4">
                  <div class="breadcrumb-box">
                    <Link to="/">Home</Link>
                  </div>
                  <div class="breadcrumb-box">
                    <Link to="/my-stories">Stories List</Link>
                  </div>
                  <div class="breadcrumb-box">
                    <a href="javascript:void(0)">{pageType === "update" ? "Update Story" : "Add Story"}</a>
                  </div>
                </div>
                <div class="sl-title-row d-flex justify-content-between align-items-center mb-4">
                  <div class="sl-t-left">
                    <h1>{pageType === "update" ? "Update Story" : "Create New Story"}</h1>
                  </div>
                </div>
                <div class="form-floating-holder">
                  <div class="form-floating-row d-flex flex-wrap">
                    <div class="ff-column">
                      <div class="form-floating custom-form-floating">
                        <input
                          type="text"
                          class="form-control"
                          id="title"
                          name="title"
                          onChange={onChange}
                          value={storyData?.title}
                        />
                        <label for="title">Title</label>
                        {error?.title ? <p style={{ color: "red" }}>Title is required</p> : ""}
                      </div>
                    </div>
                  </div>
                  <div class="form-floating-row d-flex flex-wrap">
                    <div class="ff-column">
                      <div class="form-floating custom-form-floating">
                        <input
                          type="text"
                          class="form-control"
                          id="contributor"
                          name="contributor"
                          onChange={onChange}
                          value={storyData?.contributor}
                        />
                        <label for="contributor">Contributor</label>
                        {error?.contributor ? <p style={{ color: "red" }}>Contributor is required</p> : ""}
                      </div>
                    </div>
                  </div>
                  <div class="form-floating-row d-flex flex-wrap">
                    <div class="ff-column">
                      <div class="form-floating custom-form-floating ss-textare">
                        <textarea
                          class="form-control"
                          id="mainStory"
                          name="mainStory"
                          onChange={onChange}
                          value={storyData?.mainStory}
                        ></textarea>
                        <label className="ss-main-story-scroll" for="floatingTextarea ">
                          Main Story
                        </label>
                        {error?.mainStory ? <p style={{ color: "red" }}>Main Story is required</p> : ""}
                      </div>
                    </div>
                  </div>
                  <div class="form-floating-row d-flex flex-wrap">
                    <div class="ff-column">
                      <div class="form-floating-row d-flex flex-wrap">
                        <div class="ff-column">
                          <label htmlFor="species" className="form-label ss-category">
                            Species Categories
                          </label>
                          <Select
                            className="basic-single text-capitalize "
                            name="catgeories"
                            classNamePrefix="select-search"
                            isMulti
                            placeholder="Please Select"
                            styles={customStyles1}
                            options={dropDownData?.category}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option._id}
                            onChange={(selectedOptions) => {
                              const data = { ...dropDownData };
                              data.species = selectedOptions?.flatMap((it) => it?.species) || [];
                              setDropdownData(data);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-floating-row d-flex flex-wrap">
                    <div class="ff-column">
                      <div class="form-floating-row d-flex flex-wrap">
                        <div class="ff-column">
                          <label htmlFor="species" className="form-label ss-category">
                            Species
                          </label>
                          <Select
                            className="basic-single text-capitalize "
                            classNamePrefix="select-search"
                            loadingMessage={"Please Select"}
                            name="species"
                            placeholder="Please Select"
                            styles={customStyles1}
                            options={dropDownData?.species?.map((it) => ({
                              id: it?.id,
                              name: it?.name,
                            }))}
                            getOptionLabel={(option) => option?.name}
                            getOptionValue={(option) => option?.id}
                            value={storyData?.species}
                            onChange={(selectedOptions) => {
                              const data = { ...storyData };
                              data.species = [selectedOptions];
                              setStoryData(data);
                            }}
                          />
                          {error?.species ? <p style={{ color: "red" }}>Species are required</p> : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="upload-media-row">
                  <h3>Upload Featured Image</h3>
                  <div class="upload-media-list d-flex flex-wrap">
                    {selectedUploadMedia?.featuredImage?.length === 0 && storyData?.featuredImage?.length === 0 && (
                      <div class="upload-media-item">
                        <div class="upload-media-box position-relative">
                          <div class="umd-upload-box d-flex justify-content-center align-items-center text-center">
                            Click / Drag and Drop <br /> Upload Image
                            <input
                              class="form-control user-story-file-select"
                              type="file"
                              id="formFile"
                              accept=".jpg,.jpeg,.png,.webp"
                              onChange={(e) => onSelectMedia(e, "image", "featuredImage")}
                              onClick={(e) => (e.target.value = null)}
                            />
                          </div>
                          {error?.featuredImage ? <p style={{ color: "red" }}> Featured Image is required</p> : ""}
                        </div>
                      </div>
                    )}
                    {storyData?.featuredImage?.length > 0
                      ? storyData?.featuredImage?.map((je) => (
                          <div class="upload-media-item">
                            <div class="upload-media-box position-relative">
                              <div class="umb-img ">
                                <img src={process.env.REACT_APP_MEDIA + je?.media} alt="" />
                              </div>
                              <div class="umd-btn-box d-flex gap-1">
                                <button
                                  type="button"
                                  class="umb-btn d-flex justify-content-center align-items-center"
                                  onClick={() => removeExistingImages(je?.media, "featuredImage")}
                                >
                                  <img src={deleteIcon} alt="" />
                                </button>
                              </div>
                            </div>
                          </div>
                        ))
                      : selectedUploadMedia?.featuredImage?.map((je, i) => (
                          <div class="upload-media-item">
                            <div class="upload-media-box position-relative">
                              <div class="umb-img ss-object-contain">
                                <img src={`${URL.createObjectURL(selectedUploadMedia?.featuredImage?.[i])}`} alt="" />
                              </div>
                              <div class="umd-btn-box d-flex gap-1">
                                <button
                                  type="button"
                                  class="umb-btn d-flex justify-content-center align-items-center"
                                  onClick={() =>
                                    removeUploaded(selectedUploadMedia?.featuredImage?.[i], "featuredImage")
                                  }
                                >
                                  <img src={deleteIcon} alt="" />
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                  </div>
                </div>
                <div class="upload-media-row">
                  <h3>Upload Photos</h3>
                  <div class="upload-media-list d-flex flex-wrap">
                    <div class="upload-media-item">
                      <div class="upload-media-box position-relative">
                        <div class="umd-upload-box d-flex justify-content-center align-items-center text-center">
                          Click / Drag and Drop <br /> Upload Image
                          <input
                            class="form-control user-story-file-select"
                            type="file"
                            id="formFile"
                            accept=".jpg,.jpeg,.png,.webp"
                            multiple
                            onChange={(e) => onSelectMedia(e, "image", "photos")}
                            onClick={(e) => (e.target.value = null)}
                          />
                        </div>
                      </div>
                    </div>
                    {selectedUploadMedia?.photos?.map((je, i) => (
                      <div class="upload-media-item">
                        <div class="upload-media-box position-relative">
                          <div class="umb-img">
                            {je?.media ? (
                              <img src={process.env.REACT_APP_MEDIA + je?.media} alt="" />
                            ) : (
                              <img src={`${URL.createObjectURL(selectedUploadMedia?.photos?.[i])}`} alt="" />
                            )}
                          </div>
                          <div class="umd-btn-box d-flex gap-1">
                            <button
                              type="button"
                              class="umb-btn d-flex justify-content-center align-items-center"
                              onClick={() => removeUploaded(selectedUploadMedia?.photos?.[i], "photos")}
                            >
                              <img src={deleteIcon} alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                    {storyData?.photos?.map((je, i) => (
                      <div class="upload-media-item">
                        <div class="upload-media-box position-relative">
                          <div class="umb-img">
                            <img src={process.env.REACT_APP_MEDIA + je?.media} alt="" />
                          </div>
                          <div class="umd-btn-box d-flex gap-1">
                            <button
                              type="button"
                              class="umb-btn d-flex justify-content-center align-items-center"
                              onClick={() => removeExistingImages(je?.media, "photos")}
                            >
                              <img src={deleteIcon} alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {error?.photos ? <p style={{ color: "red" }}>Images are required</p> : ""}
                </div>
                <div class="upload-media-row">
                  <h3>Upload Videos</h3>
                  <div class="upload-media-list d-flex flex-wrap">
                    <div class="upload-media-item">
                      <div class="upload-media-box position-relative">
                        <div class="umd-upload-box d-flex justify-content-center align-items-center text-center">
                          Click / Drag and Drop <br /> Upload Video
                          <input
                            class="form-control user-story-file-select"
                            type="file"
                            id="formFile"
                            accept=".mov,.mp4,.avi"
                            onChange={(e) => onSelectMedia(e, "videos", "videos")}
                            onClick={(e) => (e.target.value = null)}
                          />
                        </div>
                      </div>
                    </div>
                    {selectedUploadMedia?.videos?.map((je, i) => (
                      <div class="upload-media-item">
                        <div class="upload-media-box position-relative">
                          <div class="umb-img">
                            <video width="100%" controls>
                              {je?.media ? (
                                <source src={process.env.REACT_APP_MEDIA + je?.media} />
                              ) : (
                                <source
                                  src={`${URL.createObjectURL(selectedUploadMedia?.videos?.[i])}`}
                                  type={selectedUploadMedia?.videos?.[i]?.type}
                                />
                              )}
                              Your browser does not support the video tag.
                            </video>
                          </div>
                          <div class="umd-btn-box d-flex gap-1">
                            <button
                              type="button"
                              class="umb-btn d-flex justify-content-center align-items-center"
                              onClick={() => removeUploaded(selectedUploadMedia?.videos?.[i], "videos")}
                            >
                              <img src={deleteIcon} alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                    {storyData?.videos?.map((je, i) => (
                      <div class="upload-media-item">
                        <div class="upload-media-box position-relative">
                          <div class="umb-img">
                            <video width="100%" controls>
                              <source src={process.env.REACT_APP_MEDIA + je?.media} />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                          <div class="umd-btn-box d-flex gap-1">
                            <button
                              type="button"
                              class="umb-btn d-flex justify-content-center align-items-center"
                              onClick={() => removeExistingImages(je?.media, "videos")}
                            >
                              <img src={deleteIcon} alt="" />
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <a
                  href="javascript:void(0);"
                  class={`btn btn-default btn-post upload-user-story ${loading ? "disabled" : ""} `}
                  onClick={() => onSubmit()}
                >
                  {pageType === "update" ? "Update Story" : "Submit Story"}
                </a>
              </div>
            </div>
          </div>
        </div>
      </PageLayout>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  saveUserStory: (data, callback) => dispatch(saveUserStory(data, callback)),
  updateUserStory: (id, data, callback) => dispatch(updateUserStory(id, data, callback)),
  getUserStoryDetail: (params, id, callback) => dispatch(getUserStoryDetail(params, id, callback)),
  getSpeciesCategoryList: (params, callback) => dispatch(getSpeciesCategoryList(params, callback)),
  getSpeciesList: (params, callback) => {
    dispatch(getSpeciesList(params, callback));
  },
});

const mapStateToProps = (state) => ({
  userStoryData: userStoryData(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(UpdateCustomerStory));
